import { render, staticRenderFns } from "./cardPatient.vue?vue&type=template&id=8d7dd724&"
import script from "./cardPatient.vue?vue&type=script&lang=js&"
export * from "./cardPatient.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports